import React from 'react';
import { useRouteMatch, Link } from 'react-router-dom';
import { get } from 'lodash';
import moment from 'moment';
import BoardDetail from 'components/base/BoardDetail';
import { getRecruitment } from 'libs/api/main';
import { useDataApi, useTimezone } from 'libs/hooks';
import { commifyFormatter } from 'libs/validators';
import { TRecruitment } from 'modules/main';
import { RouteMatch } from 'modules/types';
import { CDateFormat, CDateTimeFormat } from 'constants/base.const';
import { EOperation } from 'enums/base.enum';
import { ERoute } from 'enums/route.enum';
import { Spin, Typography, Button, Descriptions } from 'antd';
import { LeftOutlined } from '@ant-design/icons/lib';
import styled from 'styled-components';
import { PrimaryColor } from 'GlobalStyles';

const { Text, Title } = Typography;
export const RecruitmentViewWrapper = styled.div`
  padding-top: 30px;
  margin: 30px auto 100px auto;
  max-width: 800px;
  .ant-descriptions-item-label {
    background-color: #fff !important;
    width: 30%;
    font-weight: bold;
  }
  .ant-descriptions {
    margin-top: 30px;
  }
  .ant-descriptions-item-content {
    color: #000;
  }
  .small-btn {
    margin-bottom: 10px;
    padding: 0px 10px !important;
  }
  .multi-line {
    white-space: pre-line;
    word-break: break-word;
  }
`;
const CompanyParttimeView = () => {
  const match = useRouteMatch(`${ERoute.CompanyParttimeView}`);
  const { record_id } = (match?.params as RouteMatch) || {};
  const [{ data, loading }] = useDataApi<TRecruitment>(getRecruitment.bind(null, record_id));
  const [getDateTime, timezone] = useTimezone();
  const versionBefore = '2021/01/23'; // 표 형식으로 작성하던 내용들은 표로 표현

  return (
    <>
      {moment(get(data, 'created_at')) < moment(versionBefore) ? (
        <RecruitmentViewWrapper className='no-drag'>
          <Link to={ERoute.CompanyParttime}>
            <Button className='small-btn'>
              <LeftOutlined />
              목록으로
            </Button>
          </Link>
          <Spin tip='loading...' spinning={loading}>
            <Title level={2}>
              [{get(data, 'company_name')}] {get(data, 'title')}
            </Title>
            <Descriptions size='small' column={1} bordered>
              <Descriptions.Item label='회사명'>{get(data, 'company_name')}</Descriptions.Item>
              <Descriptions.Item label='공고 제목'>{get(data, 'title')}</Descriptions.Item>
              <Descriptions.Item className='multi-line' label='업무 내용'>
                {get(data, 'body')}
              </Descriptions.Item>
              <Descriptions.Item label='지원 대상'>
                {get(data, 'target') ? get(data, 'target') : '제한없음'}
              </Descriptions.Item>
              <Descriptions.Item className='multi-line' label='지원 자격'>
                {get(data, 'requirement')}
              </Descriptions.Item>
              <Descriptions.Item className='multi-line' label='지원 방법'>
                {get(data, 'how_to_apply')}
              </Descriptions.Item>
              <Descriptions.Item label='채용 기간'>
                {getDateTime(get(data, 'recruitment_from'))
                  .format(CDateTimeFormat)
                  .replace('PM', '오후')
                  .replace('AM', '오전')}{' '}
                ~&nbsp;
                {get(data, 'recruitment_to') ? (
                  <span>
                    {getDateTime(get(data, 'recruitment_to'))
                      .format(CDateTimeFormat)
                      .replace('PM', '오후')
                      .replace('AM', '오전')}
                  </span>
                ) : (
                  <span>ASAP</span>
                )}
              </Descriptions.Item>
              <Descriptions.Item label='채용 과정'>{get(data, 'recruitment_process')}</Descriptions.Item>
              <Descriptions.Item label='근무 기간'>
                {get(data, 'employment_from') ? (
                  <span>
                    {getDateTime(get(data, 'employment_from'))
                      .format(CDateFormat)
                      .replace('PM', '오후')
                      .replace('AM', '오전')}
                  </span>
                ) : (
                  <span>ASAP</span>
                )}
                &nbsp;~{' '}
                {getDateTime(get(data, 'employment_to'))
                  .format(CDateFormat)
                  .replace('PM', '오후')
                  .replace('AM', '오전')}
              </Descriptions.Item>
              <Descriptions.Item label='시급'>
                {get(data, 'salary') ? commifyFormatter(String(get(data, 'salary'))) : ''}
              </Descriptions.Item>
              <Descriptions.Item label='담당자 연락처'>
                <span style={{ color: `${PrimaryColor}` }}>
                  {get(data, 'responsible_name')},&nbsp;
                  <a style={{ color: `${PrimaryColor}` }} href={`mailto:${get(data, 'responsible_email')}`}>
                    {get(data, 'responsible_email')}
                  </a>
                </span>
              </Descriptions.Item>
              <Descriptions.Item className='multi-line' label='기타'>
                {get(data, 'etc')}
              </Descriptions.Item>
            </Descriptions>
          </Spin>
        </RecruitmentViewWrapper>
      ) : (
        <BoardDetail
          operation={EOperation.View}
          pathName={ERoute.CompanyParttime}
          record={data}
          loading={loading}
          useFile={false}
          useThumbnail={true}
        />
      )}
    </>
  );
};

export default CompanyParttimeView;
